
document.addEventListener("DOMContentLoaded", function () {
  var form = document.querySelector("#ContactForm");
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    form.querySelector("button").disabled = true;
    form.classList.add("loading");
    if (!_iaq.isIAQ) {
      form.submit();
      return;
    }

    var dataFields = {};
    var formData = new FormData(form);
    var keys = formData.keys();
    for (var key of keys) {
      var nKey = key.replace("[", "_").replace("]", "");
      if (nKey.includes("contact_")) dataFields[nKey] = formData.get(key);
    }

    window.theme.utils.klaviyo(dataFields["contact_email"], {
      contactForm: true,
    });
    window.theme.utils.klaviyo("contactFormSubmitted", dataFields, "track");
    setTimeout(function () {
      form.classList.remove("loading");
      form.classList.add("success");
    }, 1000);
  });

  // window.window.themeRecaptchaEnable = function(){
  //   var button = document.querySelector('#ContactForm-Submit')
  //   button.disabled = false
  // }

  // window.window.themeRecaptchaDisable = function(){
  //   var button = document.querySelector('#ContactForm-Submit')
  //   button.disabled = true
  // }

  // window.themeRecaptchaDisable()
});

document.addEventListener("DOMContentLoaded", function () {
  const contactFormSelector = document.querySelector(
    "#contact-form--selector select"
  );
  const formDivs = document.querySelectorAll(".contact-form-box");

  contactFormSelector.addEventListener("change", function (event) {
    const selectedValue = event.target.value;
    // console.log(selectedValue);

    // Hide all form divs
    formDivs.forEach((div) => {
      div.classList.remove("show");
    });

    // Show the selected form div
    const selectedFormDiv = document.getElementById(selectedValue);
    // console.log(selectedFormDiv);
    if (selectedFormDiv) {
      selectedFormDiv.classList.add("show");
    }
  });
});
